<template>
    <div class="dashboard">
        <h1>Billing Dashboard</h1>
        <b-card footer-class="p-0">
            <b-card-group deck>
                <b-card no-body class="border-0">
                    <sales-by-item-type></sales-by-item-type>
                </b-card>
                <b-card no-body class="border-0">
                    <sales-by-patient-species></sales-by-patient-species>
                </b-card>
                <b-card no-body class="border-0">
                    <payment-by-type></payment-by-type>
                </b-card>
            </b-card-group>
            <template v-slot:footer no-body>
                <b-tabs
                    card
                    lazy
                    class="list tab-table-responsive"
                    ref="btabs"
                    v-model="activeTabIndex"
                    v-if="isRendered"
                >
                    <tab-invoices
                        ref="tab-invoices"
                        tabname="tab-invoices"
                        @open-new-invoice="openNewInvoice"
                        @redirect-other-tab="reloadTabList"
                    />
                    <tab-estimates
                        ref="tab-estimates"
                        tabname="tab-estimates"
                        @open-new-estimate="openModal('createEstimateWindow')"
                    />
                    <tab-payments
                        ref="tab-payments"
                        tabname="tab-payments"
                        @create-payment="createPayment"
                    />
                    <tab-returns
                        ref="tab-returns"
                        tabname="tab-returns"
                        @redirect-other-tab="reloadTabList"
                        @open-new-return="openModal('modalNewReturn')"
                    />
                    <tab-credits
                        ref="tab-credits"
                        tabname="tab-credits"
                        @open-new-credit="openModal('createUpdateCredit')"
                    />
                    <tab-refunds ref="tabRefunds" tabname="tab-refunds" />
                    <tab-write-offs
                        ref="tab-write-offs"
                        tabname="tab-write-offs"
                        @create-new-writeoff="openModal('modalCreate')"
                    />
                    <tab-cash
                        v-if="
                            _hasAccess('billing.cash.create') ||
                            _hasAccess('billing.cash.update')
                        "
                        ref="tab-cash"
                        tabname="tab-cash"
                        @open-new-cash-reconciliation="
                            openModal('createUpdateCashReconciliation')
                        "
                    />
                </b-tabs>
            </template>
        </b-card>
        <modal-create
            ref="modalCreate"
            modal-ref="modal-save-writeoff"
            @reload="reloadTabList('tab-write-offs')"
        />
        <create-update-cash-reconciliation
            ref="createUpdateCashReconciliation"
            @reload="reloadTabList('tab-cash')"
        />
        <create-update-credit
            ref="createUpdateCredit"
            modal-id="modal-create-credit"
            @reload="reloadTabList('tab-credits')"
        />
        <createPayment
            ref="createPaymentWindow"
            @reload="reloadTabList('tab-payments')"
        />
        <new-invoice ref="newInvoice" />
        <modal-new-return ref="modalNewReturn" modalRef="modalNewReturn" />
        <createEstimate ref="createEstimateWindow" />
    </div>
</template>
<script>
import "@/jquery/jquery.flot";
import "@/jquery/jquery.flot.tooltip";
import "@/jquery/jquery.flot.pie";
import { findIndex } from "lodash";
import TabInvoices from "@/module/billing/tabs/dashboard/tab-invoices";
import TabEstimates from "@/module/billing/tabs/dashboard/tab-estimates";
import TabPayments from "@/module/billing/tabs/dashboard/tab-payments";
import TabReturns from "@/module/billing/tabs/dashboard/tab-returns";
import TabCredits from "@/module/billing/tabs/dashboard/tab-credits";
import TabRefunds from "@/module/billing/tabs/dashboard/tab-refunds";
import TabWriteOffs from "@/module/billing/tabs/dashboard/tab-write-offs";
import TabCash from "@/module/billing/tabs/dashboard/tab-cash";
import NewInvoice from "@/components/new-invoice/invoice-modal.vue";
import paymentByType from "@/module/report/module/billing/payment_by_type.vue";
import salesByItemType from "@/module/report/module/billing/sales_by_item_type.vue";
import salesByPatientSpecies from "@/module/report/module/billing/sales_by_patient_species.vue";
import ModalCreate from "@/components/billing-writeoffs/writeoff-save-modal";
import CreateUpdateCashReconciliation from "@/components/billing-cash/create-update";
import CreateUpdateCredit from "@/components/billing-credit/credit-edit-modal";
import CreatePayment from "@/components/new-payment/payment-modal.vue";
import ModalNewReturn from "@/components/billing-returns/new-return.vue";
import CreateEstimate from "@/components/client-estimates/estimate-new-modal.vue"; // temporary, will update to new modal once API is updated

const TAB = {
    "": 0,
    INVOICES: 0,
    ESTIMATES: 1,
    PAYMENTS: 2,
    RETURNS: 3,
    CREDITS: 4,
    REFUNDS: 5,
    "WRITE-OFFS": 6,
    CASH: 7
};

export default {
    components: {
        TabInvoices,
        TabEstimates,
        TabPayments,
        TabReturns,
        TabCredits,
        TabRefunds,
        TabWriteOffs,
        TabCash,
        NewInvoice,
        paymentByType,
        salesByItemType,
        salesByPatientSpecies,
        ModalCreate,
        CreateUpdateCashReconciliation,
        CreateUpdateCredit,
        CreatePayment,
        ModalNewReturn,
        CreateEstimate
    },
    data() {
        return {
            isRendered: false,
            activeTabIndex: 0,
            TAB
        };
    },
    computed: {},
    mounted() {
        this.reloadPageDetails();
    },
    watch: {
        "$route.query.tab"() {
            this.reloadPageDetails();
        },
        activeTabIndex(val) {
            if (val == 0) {
                this.changeRoute("invoices");
            } else if (val == 1) {
                this.changeRoute("estimates");
            } else if (val == 2) {
                this.changeRoute("payments");
            } else if (val == 3) {
                this.changeRoute("returns");
            } else if (val == 4) {
                this.changeRoute("credits");
            } else if (val == 5) {
                this.changeRoute("refunds");
            } else if (val == 6) {
                this.changeRoute("write-offs");
            } else if (val == 7) {
                this.changeRoute("cash");
            }
        }
    },
    methods: {
        async reloadPageDetails() {
            await this._getSetting(); // wait for render hasAccess
            this.isRendered = true;
            let query = this.$route.query;

            if (
                !_.isEmpty(query) &&
                query.tab &&
                !Object.keys(TAB).includes(query.tab.toUpperCase())
            ) {
                this.activeTabIndex = 0;

                this.$nextTick(() => {
                    this.reloadTabList(query.tab, query);

                    // clear url params once done
                    let url = new URL(window.location.href);
                    url.search = "";
                    history.replaceState({}, null, url.toString());
                });
            } else if (!_.isEmpty(query) && query.tab) {
                this.activeTabIndex = TAB[this.$route.query.tab.toUpperCase()];
            }
        },
        reloadTabList(tabName, query = null) {
            this.activeTabIndex = this.findTabIndex(tabName);

            switch (tabName) {
                case "tab-write-offs":
                    this.$refs[tabName].reloadWriteOffs();
                    break;
                case "tab-cash":
                    this.$refs[tabName].reloadCash();
                    break;
                case "tab-credits":
                    this.$refs[tabName].reloadCredit();
                    break;
                case "tab-payments":
                    this.$refs[tabName].reloadPayments();
                    break;
                case "tab-invoices":
                    if (query && query.list) {
                        this.$refs[tabName].displayList(Number(query.list));
                    }
                    break;
            }
        },
        checkBillingOpenModal(ref) {
            this.$store.dispatch("checkBillingLock", {
                onProceed: () => this.$refs[ref].open(),
                onError: message => this._message(message, "danger")
            });
        },
        findTabIndex(tabname) {
            return findIndex(this.$refs.btabs.$children, function (tab) {
                return tab.$attrs.tabname == tabname;
            });
        },
        openModal(ref) {
            switch (ref) {
                case "modalCreate":
                case "createUpdateCredit":
                case "createUpdateCashReconciliation":
                    this.checkBillingOpenModal(ref);
                    break;
                default:
                    this.$refs[ref].open();
            }
        },
        checkAccess(tab) {
            let hasAccessStatus = true;
            switch (tab) {
                case "orders":
                    hasAccessStatus =
                        this._hasAccess("inventory.purchase.order.view") ||
                        this._hasAccess("inventory.purchase.order.create") ||
                        this._hasAccess("inventory.purchase.order.edit") ||
                        this._hasAccess("inventory.purchase.order.delete");
                    break;
                case "receipts":
                    hasAccessStatus = this._hasAccess(
                        "inventory.purchase.order.view.receipt"
                    );
            }
            return hasAccessStatus;
        },
        onSuccessBulkUpdate() {
            if (this.activeTabIndex == this.findTabIndex("tabQuickEdit")) {
                this.reloadTabList("tabQuickEdit");
            }
        },
        createPayment() {
            this.$refs.createPaymentWindow.open();
        },
        openNewInvoice() {
            this.$refs.newInvoice.open();
        },
        changeRoute(tab) {
            if (this.$route.fullPath !== `/billing/dashboard?tab=${tab}`) {
                this.$router.push(`/billing/dashboard?tab=${tab}`);
            }
        }
    }
};
</script>
